/**
 * Ask the media endpoint for a resized copy.
 *
 * The server generates and caches a WebP at the requested width; a real 2 MB PNG comes back
 * at about 31 KB for the 320px thumbnail. Only 320, 640 and 1280 are accepted — an open
 * width parameter would let anyone fill the disk with variants — and anything else is served
 * as the original, so passing an unsupported width degrades rather than breaks.
 *
 * Videos and GIFs are returned untouched: sharp does not resize them, and the server falls
 * back to the original for those extensions anyway.
 */
export const thumbnailUrl = (url: string, width: 320 | 640 | 1280): string => {
  if (!url) return url;
  // Only our own media endpoint takes the parameter. An external URL is left alone.
  if (!url.includes('/api/media-file/')) return url;
  if (!/\.(jpe?g|png|webp)(\?|$)/i.test(url)) return url;
  return url + (url.includes('?') ? '&' : '?') + 'w=' + width;
};
